import React, { useEffect, useState } from "react";
import Table from "./Table";
import api from "../globals/axios";
import axios from "axios";
import {
  getBlockchainNodeUrl,
  FARMLAND_TOKEN_TYPE_CONVENTION,
  AGRI_COMMODITY_TYPE_CONVENTION,
  STORAGE_TYPE_CONVENTION,
  PRODUCT_TYPE_CONVENTION,
  WAREHOUSE_TYPE_CONVENTION,
  PROCESSING_PLANT_TYPE_CONVENTION,
  CROP_TOKEN_TYPE_CONVENTION,
} from "../globals/const";
import { getDecimal } from "../globals/utils";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";

export function WalletTokensTable({
  walletAddress,
  // setWalletBalancesParent,
  walletType,
}) {
  console.log("getting tokens for", walletAddress);
  const [walletBalances, setWalletBalances] = useState([]);
  const [transferAmount, setTransferAmount] = useState("");
  const [partnerList, setPartnerList] = useState([]);
  const [partner, setPartner] = useState("");
  const [isTransferPopupOpen, setIsTransferPopupOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);

  const columns = [
    {
      Header: "Token",
      Cell: (row) => {
        const token = row.cell.row.original;
        const handleTokenCell = (token_code, token_type) => {
          if (
            token_type === FARMLAND_TOKEN_TYPE_CONVENTION ||
            token_type === PROCESSING_PLANT_TYPE_CONVENTION ||
            token_type === WAREHOUSE_TYPE_CONVENTION ||
            token_code.startsWith("LAND") ||
            token_code.startsWith("FARM")
          )
            window.open("/view-land/?token_code=" + token_code);
          else if (token_code.startsWith("BATCH")) {
            window.open("/view-product/?token_code=" + token_code);
          } else if (token_code.startsWith("HARVEST")) {
            window.open("/view-harvest/?token_code=" + token_code);
          } else if (token_code.startsWith("CROP")) {
            window.open("/view-crop/?token_code=" + token_code);
          } else {
            window.open(
              getBlockchainNodeUrl() + "/get-token?token_code=" + token_code
            );
          }
        };
        return (
          <td
            border="none"
            onClick={() => handleTokenCell(token.token_code, token.token_type)}
          >
            {token.token_code}
          </td>
        );
      },
    },
    {
      Header: "Balance",
      accessor: "balance",
      Cell: (row) => <td {...row.cell.getCellProps()}>{row.cell.value}</td>,
    },
    {
      Header: "Transfer",
      accessor: "transfer",
      Cell: ({ row }) => (
        <Button onClick={() => handleTransferOpen(row)}>Transfer</Button>
      ),
    },
  ];

  // Loads partners
  useEffect(() => {
    api.get(`/auth/get-partners`).then((res) => {
      if (res.status === 200) {
        setPartnerList(res.data.partners);
      }
    });
  }, []);

  // Loads relevant token into wallet balances
  useEffect(() => {
    const extension = {
      DEFAULT: "",
      FARMLAND: "&token_type=" + FARMLAND_TOKEN_TYPE_CONVENTION,
      WAREHOUSELAND: "&token_type=" + WAREHOUSE_TYPE_CONVENTION,
      HARVEST: "&token_type=" + AGRI_COMMODITY_TYPE_CONVENTION,
      CROP: "&token_type=" + CROP_TOKEN_TYPE_CONVENTION,
      STORAGE: "&token_type=" + STORAGE_TYPE_CONVENTION,
      PRODUCT: "&token_type=" + PRODUCT_TYPE_CONVENTION,
      BATCHES: "&token_type=" + PRODUCT_TYPE_CONVENTION,
    };

    let url =
      getBlockchainNodeUrl() +
      "/get-balances?balance_type=ALL_TOKENS_IN_WALLET&wallet_address=" +
      walletAddress;
    if (extension[walletType]) {
      url += extension[walletType];
    }

    axios
      .get(url)
      .then((res) => res.data.balance)
      .then((data) =>
        data.map((d) => {
          return { ...d, balance: d["balance"] / getDecimal(d["token_code"]) };
        })
      )
      .then((data) => {
        if (walletType === "DEFAULT") {
          data.forEach(addTokenType);

          async function addTokenType(value) {
            await axios
              .get(
                getBlockchainNodeUrl() +
                  "/get-token?token_code=" +
                  value.token_code
              )
              .then((res) => res.data.tokentype)
              .then((tokentype) => (value.token_type = tokentype));
          }
        }
        setWalletBalances(data);
        // setWalletBalancesParent(data);
      });
  }, [walletAddress]);

  const handleTransferOpen = (row) => {
    setSelectedToken(row.original.token_code);
    setIsTransferPopupOpen(true);
  };

  const handleTransfer = () => {
    api.post("/chain/submit-token", {
      transfer_amount: transferAmount,
      recipient_email: partner.partner_email,
      transfer_token: selectedToken,
    });
    setIsTransferPopupOpen(false);
    window.alert("Transfer Succesful!");
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContents: "center",
        marginTop: "10px",
        marginBottom: "10px",
      }}
    >
      {walletBalances.length === 0 ? (
        <Box style={{ display: "flex", justifyContent: "center" }}>
          <Typography>No Tokens available in wallet</Typography>
        </Box>
      ) : (
        <>
          <Table columns={columns} data={walletBalances} />
          <Dialog
            open={isTransferPopupOpen}
            onClose={() => setIsTransferPopupOpen(false)}
          >
            <DialogTitle>Transfer Token</DialogTitle>
            <DialogContent>
              <Typography>Selected Token: {selectedToken}</Typography>
              {/* Add inputs and labels for transfer here */}
              <TextField
                label="Transfer Amount"
                variant="outlined"
                fullWidth
                value={transferAmount}
                onChange={(e) => setTransferAmount(e.target.value)}
              />
              <Select
                label="Partner Address"
                variant="outlined"
                fullWidth
                value={partner.partner_email}
                onChange={(e) => setPartner(e.target.value)}
              >
                {partnerList.map((partner) => (
                  <MenuItem key={partner.partner_email} value={partner}>
                    {partner.partner_email}
                  </MenuItem>
                ))}
              </Select>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setIsTransferPopupOpen(false)}>
                Cancel
              </Button>
              <Button color="primary" onClick={handleTransfer}>
                Transfer
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Box>
  );
}
